import styled from 'styled-components';
import Button from '../button/Button';
export const BlueContainer = styled.div `
  width: 100%;
  padding: 8.9rem 2.2rem 2.2rem;

  background: linear-gradient(144.31deg, #3d62d7 -16.06%, #191c7a 121.84%);

  border-radius: ${({ theme }) => theme.borderRadius.highM};
`;
export const GlassWrapper = styled.div `
  height: 100%;
  width: 100%;
  padding: 10rem 1rem 1rem;
  position: relative;

  border: 0.01rem solid ${({ theme }) => `${theme.colors.text.interactive}4D`};
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  box-shadow: 0px 4px 134px 0px #ffffff40 inset;
`;
export const UsdtImg = styled.img `
  height: 16.8rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: -7rem;

  ${({ theme }) => theme.media.laptop `
      height: 32rem;
  `}
`;
export const TextAndButtonWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 2.2rem;
  ${({ theme }) => theme.media.laptop `
      gap: 1.2rem;
  `}
`;
export const CustomButton = styled(Button) `
  height: 6rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  margin-top: 2.2rem;
  ${({ theme }) => theme.media.laptop `
    margin-top: 1.6rem;
  `}
`;
export const ContentWrapper = styled.div `
  ${({ theme }) => theme.media.laptop `
        display: flex;
        flex-direction: column;
        justify-content: center;

        margin: 2rem 0;
    `}
`;
export const DescWrapper = styled.ul `
  display: flex;
  text-align: start;
  flex-direction: column;
  list-style-position: inside;

  li {
    display: list-item;
    list-style-type: disc;
  }

  li::marker {
    height: 0.5rem;
    width: 0.5rem;
    color: ${({ theme }) => theme.colors.text.interactive};
  }

  ${({ theme }) => theme.media.tablet `
    max-width: 63rem;
`};
`;
//# sourceMappingURL=styles.js.map